'use es6';

export const CURRENT_REVISION_ID = -1;